/**
 * Extract email from location object (works on both client and server)
 * @param {Object} location - The location object from props or params
 * @returns {string|null} - The extracted email or null if not found
 */
export const extractEmailFromLocation = (location) => {
  let email = null;
  try {
    if (location && location.search) {
      email = new URLSearchParams(location.search).get('email');
    } else if (location && location.query && location.query.email) {
      // Some frameworks provide query params directly
      email = location.query.email;
    }

    // Decode the email from base64 if it exists (UTF-8; query may be URI-encoded)
    if (email) {
      try {
        if (typeof window === 'undefined') {
          email = Buffer.from(email, 'base64').toString('utf-8');
        } else {
          // Mirror UTF-8-safe encoding used by buildAuthCodePath / passwordless signup
          const binary = atob(email);
          email = decodeURIComponent(
            Array.from(binary, (char) => {
              const hex = char.charCodeAt(0).toString(16).padStart(2, '0');
              return `%${hex}`;
            }).join('')
          );
        }
      } catch (decodeError) {
        console.error('Failed to decode email from base64:', decodeError);
        // If decoding fails, use the original email value
      }
    }
  } catch (err) {
    // Silent error handling - error state will be shown in UI
  }
  return email;
};
